import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { getTermsDetail } from 'src/service/join'
import { TermsModalWrap } from 'src/styles/common'
import useAPI from '../../hooks/useAPI'
import { TermsDetail } from 'src/types/type'

const TermsModal = (): JSX.Element => {
  const params = useParams()
  const telecom = parseInt(params.telecom as string)
  const termsOrderIdx = parseInt(params.termsOrderIdx as string)
  const [terms, setTerms] = useState<TermsDetail>({ TermsTitle: '', TermsContents: '' })

  const api = useAPI('PartnerTermsDetail')
  const { data: termsDetail, isSuccess } = api?.useSetQuery({
    Telecom: telecom,
    Idx: termsOrderIdx
  })

  useEffect(() => {
    if (!!termsDetail?.Body) {
      const { TermsTitle, TermsContents } = getTermsDetail(termsDetail.Body)
      setTerms({ TermsTitle: TermsTitle || '', TermsContents: TermsContents || '' })
    }
  }, [termsDetail, isSuccess])

  return (
    <TermsModalWrap active={isSuccess}>
      {
        terms && <>
          <h2>{terms.TermsTitle}</h2>
          <pre dangerouslySetInnerHTML={{ __html: terms.TermsContents }} />
        </>
      }
    </TermsModalWrap>
  )
}
export default TermsModal
